"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var components_1 = require("components");
var uuid_1 = require("uuid");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var headers = [
    'quantity',
    'finishing',
    'deliveryMethod',
    'printProvider'
];
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var calc = function (text, c, p, minLength) {
    if (minLength === void 0) { minLength = 0; }
    var dataKey = '__' + c.replace(/-/g, '');
    var length = Math.max(minLength, (0, text_1.calculateStringLength)(text));
    var prevValue = p[dataKey];
    if (prevValue && prevValue.length < length) {
        prevValue.text = text;
        prevValue.length = length;
    }
    else if (!prevValue) {
        p[dataKey] = {
            text: text,
            length: length
        };
    }
    return p;
};
var sortItems = function (items) {
    return items.sort(function (a, b) {
        if (b.distributionName || a.distributionName) {
            var diff = (a.distributionName || '').localeCompare(b.distributionName || '');
            if (diff !== 0) {
                return diff;
            }
        }
        var an = a.user ? userLens_1.getName.get(a.user) : '';
        var bn = b.user ? userLens_1.getName.get(b.user) : '';
        return an.localeCompare(bn);
    });
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.setItems(sortItems(this.props.distributionRecipients));
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.items;
        if (this.props.distributionRecipients !== prevProps.distributionRecipients) {
            this.props.setItems(sortItems(this.props.distributionRecipients));
        }
        if (prevProps.items !== items) {
            var contentWidth_1 = 0;
            var columns_1 = items.reduce(function (p, item, i) {
                Object.keys(item).forEach(function (c) {
                    if (c === 'id' || c === 'excluded' || c === 'uuid') {
                        return;
                    }
                    if (c === 'user') {
                        var name = item.user ? userLens_1.getName.get(item.user) : '';
                        var address = item.user ? userLens_1.getAddress.get(item.user) : '';
                        calc(name, 'name', p);
                        calc(address, 'address', p);
                    }
                });
                return p;
            }, {});
            calc((0, translation_1.getLocalization)("distribution/recipientList/name").toString(), 'name', columns_1);
            calc((0, translation_1.getLocalization)("distribution/recipientList/address").toString(), 'address', columns_1);
            calc((0, translation_1.getLocalization)("distribution/recipientList/quantity").toString(), 'quantity', columns_1, (0, text_1.calculateStringLength)('100') + 30);
            calc((0, translation_1.getLocalization)("distribution/recipientList/finishing").toString(), 'finishing', columns_1, 160);
            calc((0, translation_1.getLocalization)("distribution/recipientList/deliveryMethod").toString(), 'deliveryMethod', columns_1, 160);
            calc((0, translation_1.getLocalization)("distribution/recipientList/printProvider").toString(), 'printProvider', columns_1, 160);
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('RecipientsListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'RecipientsListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2 * 40;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(" .".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}));
function getRecipientErr(deliveryMethod, err) {
    return err && err['recipients'] && deliveryMethod === -1 ? 'error' : '';
}
function getPrintProvider(printProvider, list) {
    return (list.find(function (a) { return printProvider === a.id; }) || {
        id: -1,
        name: (0, translation_1.getLocalization)('userfront/distribution/wizard/select')
    });
}
var quantity = function (data) { return (React.createElement(sok_ui_1.Dropdown2, null,
    React.createElement(sok_ui_1.TextInput, { editable: false, disabled: data.disableFields, value: data.value, iconRight: React.createElement("span", { className: 'icon-container' },
            React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
    !data.disableFields && (React.createElement(sok_ui_1.Dropdown2Menu, null, data.quantities.map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "quantity-".concat(i), onClick: function () {
            return data.changeDistributionRecipientQuantity &&
                data.changeDistributionRecipientQuantity(data.uuid)(x);
        } }, x.label)); }))))); };
var finishing = function (data) {
    var f = data.finishings.list.find(function (a) { return a.id === data.value; });
    return (React.createElement(sok_ui_1.Dropdown2, null,
        React.createElement(sok_ui_1.TextInput, { editable: false, disabled: data.disableFields, value: f && (0, translation_1.getLocalization)(f.name), iconRight: React.createElement("span", { className: 'icon-container' },
                React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
        !data.disableFields && (React.createElement(sok_ui_1.Dropdown2Menu, null, !data.disableFields &&
            data.finishings.list.map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "finishing-".concat(i), onClick: function () {
                    return data.changeDistributionRecipientFinishing &&
                        data.changeDistributionRecipientFinishing(data.uuid)(x);
                } }, (0, translation_1.getLocalization)(x.name))); })))));
};
var deliveryMethod = function (data) {
    var d = data.deliveryMethods.list.find(function (a) { return a.id === data.value; });
    return (React.createElement(sok_ui_1.Dropdown2, null,
        React.createElement(sok_ui_1.TextInput, { editable: false, className: getRecipientErr(data.value, data.errors), disabled: data.disableFields, value: d && (0, translation_1.getLocalization)(d.name), iconRight: React.createElement("span", { className: 'icon-container' },
                React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
        !data.disableFields && (React.createElement(sok_ui_1.Dropdown2Menu, null, data.deliveryMethods.list.map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "deliveryMethod-".concat(i), onClick: function () {
                return data.changeDistributionRecipientDeliveryMethod &&
                    data.changeDistributionRecipientDeliveryMethod(data.uuid)(x);
            } }, (0, translation_1.getLocalization)(x.name))); })))));
};
var printProvider = function (data) { return (React.createElement(sok_ui_1.Dropdown2, null,
    React.createElement(sok_ui_1.TextInput, { editable: false, disabled: data.disableFields, value: getPrintProvider(data.disableFields
            ? data.value
            : (data.allowedPrintProviders
                ? data.allowedPrintProviders[0]
                : data.value) || -1, data.printProviders.list).name, iconRight: React.createElement("span", { className: 'icon-container' },
            React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
    !data.disableFields && (React.createElement(sok_ui_1.Dropdown2Menu, null, data.printProviders.list
        .filter(function (x) {
        return data.allowedPrintProviders
            ? data.allowedPrintProviders.includes(x.id)
            : true;
    })
        .map(function (x, i) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "printProvider-".concat(i), onClick: function () {
            return data.changeDistributionRecipientPrintProvider &&
                data.changeDistributionRecipientPrintProvider(data.uuid)(x);
        } }, (0, translation_1.getLocalization)(x.name))); }))))); };
function getColumn(column, data) {
    function getVal() {
        switch (column) {
            case 'quantity':
                return quantity(data);
            case 'finishing':
                return finishing(data);
            case 'deliveryMethod':
                return deliveryMethod(data);
            default:
                return printProvider(data);
        }
    }
    return (React.createElement("div", { className: classNames("row__column __".concat(column)), "data-key": "__".concat(column) }, getVal()));
}
function getHeaderColumn(props, name, identifier) {
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic recipients-list-row-column', dataKey) }, (0, translation_1.getLocalization)("distribution/recipientList/".concat(identifier)).toString()));
}
var Header = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow" }),
        React.createElement("div", { className: "row__column narrow" }),
        getHeaderColumn(props, 'name', 'name'),
        getHeaderColumn(props, 'address', 'address'),
        headers.map(function (header) { return getHeaderColumn(props, header, header); })));
};
var _createRowData = function (style, items, quantities, mode, type, removeDistributionRecipient, addDistributionRecipient, changeDistributionRecipientQuantity, changeDistributionRecipientFinishing, changeDistributionRecipientDeliveryMethod, changeDistributionRecipientPrintProvider, deliveryMethods, finishings, printProviders, allowedPrintProviders, disabledFields, errors, excludeRecipient) { return ({
    style: style,
    items: items,
    quantities: quantities,
    mode: mode,
    type: type,
    removeDistributionRecipient: removeDistributionRecipient,
    addDistributionRecipient: addDistributionRecipient,
    changeDistributionRecipientQuantity: changeDistributionRecipientQuantity,
    changeDistributionRecipientFinishing: changeDistributionRecipientFinishing,
    changeDistributionRecipientDeliveryMethod: changeDistributionRecipientDeliveryMethod,
    changeDistributionRecipientPrintProvider: changeDistributionRecipientPrintProvider,
    deliveryMethods: deliveryMethods,
    finishings: finishings,
    printProviders: printProviders,
    allowedPrintProviders: allowedPrintProviders,
    errors: errors,
    excludeRecipient: excludeRecipient,
    disabledFields: disabledFields
}); };
var RopwDataExtractable = Types.extractReturnType(_createRowData);
var createRowData = memoize(_createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, removeDistributionRecipient = data.removeDistributionRecipient, addDistributionRecipient = data.addDistributionRecipient, excludeRecipient = data.excludeRecipient, mode = data.mode;
    var row = items[index];
    var distributionRecipient = row.distributionId && data.type === 'ORDER';
    var disableFields = !!distributionRecipient;
    return (React.createElement("div", { className: classNames('row'), style: style },
        distributionRecipient ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'row__column narrow' },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.distributionName) },
                    React.createElement(components_1.TableRowIcon, { icon: 'fa-clipboard-list' }))),
            React.createElement("div", { className: 'row__column narrow' },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: row.excluded ? '' : 'purple', onClick: excludeRecipient && excludeRecipient(row.id), disabled: mode === 'VIEW' || data.disabledFields.exclude })))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'row__column narrow' },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-times-circle', onClick: function () {
                        removeDistributionRecipient &&
                            removeDistributionRecipient(row.uuid)();
                    }, className: 'red selectable', disabled: disableFields || data.disabledFields.remove })),
            React.createElement("div", { className: 'row__column narrow' },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-plus-circle', onClick: function () {
                        return addDistributionRecipient &&
                            addDistributionRecipient([
                                {
                                    finishing: row.finishing,
                                    deliveryMethod: row.deliveryMethod,
                                    printProvider: row.printProvider,
                                    distributionId: row.distributionId,
                                    distributionName: row.distributionName,
                                    quantity: 1,
                                    user: row.user,
                                    uuid: (0, uuid_1.v4)(),
                                    excluded: false
                                }
                            ], [])();
                    }, className: 'purple', disabled: disableFields || data.disabledFields.add })))),
        React.createElement("div", { className: classNames("row__column dynamic __name"), "data-key": "__name" },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.user ? userLens_1.getName.get(row.user) : '--') }, row.excluded ? (React.createElement("del", null, row.user ? userLens_1.getName.get(row.user) : '--')) : (React.createElement("span", null, row.user ? userLens_1.getName.get(row.user) : '--')))),
        React.createElement("div", { className: classNames("row__column dynamic __address"), "data-key": "__address" },
            React.createElement("span", null, row.user ? userLens_1.getAddress.get(row.user) : '')),
        getColumn('quantity', __assign(__assign({}, data), { disableFields: disableFields || data.disabledFields.quantity, value: row.quantity, uuid: row.uuid })),
        getColumn('finishing', __assign(__assign({}, data), { disableFields: disableFields || data.disabledFields.finishing, value: row.finishing, uuid: row.uuid })),
        getColumn('deliveryMethod', __assign(__assign({}, data), { disableFields: disableFields || data.disabledFields.deliveryMethod, value: row.deliveryMethod, uuid: row.uuid })),
        getColumn('printProvider', __assign(__assign({}, data), { disableFields: disableFields || data.disabledFields.printProvider, value: row.printProvider, uuid: row.uuid }))));
});
exports.ListContainer = enhance(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData({}, props.items, props.quantities, props.mode, props.type, props.removeDistributionRecipient, props.addDistributionRecipient, props.changeDistributionRecipientQuantity, props.changeDistributionRecipientFinishing, props.changeDistributionRecipientDeliveryMethod, props.changeDistributionRecipientPrintProvider, props.deliveryMethods, props.finishings, props.printProviders, props.allowedPrintProviders, props.disabledFields || {}, props.errors, props.excludeRecipient);
    return (React.createElement("div", { className: 'recipients-list-container' },
        React.createElement("div", { className: 'sok-list-content recipient-view-list' },
            React.createElement(React.Fragment, null, props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)) }, ListRow));
            }))))));
});
